<template>
  <div class="policies">
    <div class="table">
      <div class="table__header box box--default">
        <div class="table__label table__label--small">
          {{
            $t(`accountDetails.${"potentialPolicyTable"}.${"header"}.${"date"}`)
          }}
        </div>
        <div class="table__label table__label--medium">
          {{
            $t(
              `accountDetails.${"potentialPolicyTable"}.${"header"}.${"category"}`
            )
          }}
        </div>
        <div class="table__label table__label--large">
          {{
            $t(`accountDetails.${"potentialPolicyTable"}.${"header"}.${"text"}`)
          }}
        </div>
        <div class="table__label table__label--small">
          {{
            $t(`accountDetails.${"potentialPolicyTable"}.${"header"}.${"file"}`)
          }}
        </div>
        <div class="table__label table__label--medium">
          {{
            $t(
              `accountDetails.${"potentialPolicyTable"}.${"header"}.${"agent"}`
            )
          }}
        </div>
        <div class="table__label table__label--small">
          {{
            $t(
              `accountDetails.${"potentialPolicyTable"}.${"header"}.${"policy"}`
            )
          }}
        </div>
        <div class="table__label table__label--small table__label--last"></div>
      </div>

      <div class="table__body">
        <Loading v-if="detailsLoading" />
        <template v-else>
          <div v-if="!canViewPotentialPolicies" class="table__no-data">
            <NoData :type="'no-permission'" />
          </div>
          <div v-else-if="!potentialPolicies.length" class="table__no-data">
            <NoData :type="'potential-policies'" />
          </div>
          <template v-else>
            <PotentialPolicy v-for="(policy, index) in potentialPolicies" :key="policy.id" :policy="policy"
              :index="index" />
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed } from "vue";
import NoData from "@/partials/NoData";
import Loading from "@/partials/Loading";
import PotentialPolicy from "@/components/AccountDetails/PotentialPolicy";
export default {
  name: "PotentialPolicyTable",

  components: {
    NoData,
    Loading,
    PotentialPolicy,
  },

  props: {
    potentialPolicies: {
      required: true,
      type: Array,
    },

    detailsLoading: {
      required: true,
      type: Boolean,
    },
  },

  setup() {
    const store = useStore();
    const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
    const customerTeamId = computed(() => store.getters.customer?.team_id ?? store.getters.customer?.team?.id ?? null);
    const canViewPotentialPolicies = computed(() => {
      if (isSuperAdmin.value) return true;
      return store.getters.hasTeamPermission("potential_policy_access", customerTeamId.value);
    });
    return { canViewPotentialPolicies };
  },
};
</script>

<style scoped lang="scss">
.loading {
  height: 76vh;
}
</style>
